
export default {
  name: 'warning',
  props: {
    errorText: {
      type: String,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {};
  },
};
